<form
  kendoForm
  [formGroup]="entityForm"
  (ngSubmit)="onSubmit()"
  [cols]="9"
>
  <fieldset
    kendoFormFieldSet
    legend="{{ 'EntityTranslation.BaseData' | translate }}"
    [colSpan]="9"
    [cols]="12"
  >
    <kendo-formfield [colSpan]="3">
      <kendo-label translate>EntityTranslation.Code</kendo-label>
      <kendo-textbox formControlName="code"></kendo-textbox>
    </kendo-formfield>
    <kendo-formfield [colSpan]="3">
      <kendo-label translate>EntityTranslation.Description</kendo-label>
      <kendo-textbox formControlName="description"></kendo-textbox>
    </kendo-formfield>



    <kendo-formfield [colSpan]="2">
      <kendo-label translate>EntityTranslation.BaseUnitCode</kendo-label>
      <kendo-dropdownlist
        formControlName="baseUnitCode"
        [data]="units"
        textField="unitCode"
        valueField="unitCode"
        [valuePrimitive]="true"
      ></kendo-dropdownlist>
    </kendo-formfield>
    <kendo-formfield [colSpan]="2">
      <kendo-label translate>EntityTranslation.EntityStatus</kendo-label>
      <app-select-entity-status
        formControlName="status"
        [showLable]="false"
        class="width-dropdown"
      ></app-select-entity-status>
    </kendo-formfield>
    <kendo-formfield [colSpan]="2">
      <kendo-label translate>GluePlan.Dimension</kendo-label>
      <kendo-dropdownlist
        formControlName="beamLamminaDimensionId"
        [valuePrimitive]="true"
        [data]="dimensions"
        textField="description"
        valueField="beamLamminaDimensionID"
        [defaultItem]="noDimensionItem"
      ></kendo-dropdownlist>
    </kendo-formfield>
    <kendo-formfield [colSpan]="1">
      <kendo-label translate>EntityTranslation.MinStock</kendo-label>
      <kendo-numerictextbox formControlName="targetMinStock">
        <ng-template kendoSuffixTemplate>
          <button kendoButton [disabled]="true" fillMode="clear">{{ entityForm.controls.baseUnitCode.value }}</button>
        </ng-template>
      </kendo-numerictextbox>
    </kendo-formfield>
    <kendo-formfield [colSpan]="1">
      <kendo-label translate>EntityTranslation.MaxStock</kendo-label>
      <kendo-numerictextbox formControlName="targetMaxStock">
        <ng-template kendoSuffixTemplate>
          <button kendoButton [disabled]="true" fillMode="clear">{{ entityForm.controls.baseUnitCode.value }}</button>
        </ng-template>
      </kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield [colSpan]="4">
      <kendo-label
        [for]="autoGenerateProdOrder"
        translate
      >
        EntityTranslation.AutoGenerateProdOrder
      </kendo-label>
      <kendo-switch
        #autoGenerateProdOrder
        name="autoGenerateProdOrder"
        formControlName="autoGenerateProdOrder"
      ></kendo-switch>
    </kendo-formfield>
    <kendo-formfield [colSpan]="6">
      <kendo-label translate>EntityTranslation.Instruction</kendo-label>
      <kendo-textarea
        formControlName="instruction"
        [rows]="3"
      ></kendo-textarea>
    </kendo-formfield>
  </fieldset>

  <fieldset
    kendoFormFieldSet
    legend="{{ 'EntityTranslation.PropertyValues' | translate }}"
    [colSpan]="1"
  >
    <div class="property-values-list" formArrayName="propertyValues">
      @for (v of propertyValues.controls; track v; let i = $index) {
      <kendo-formfield
        [formGroupName]="i"
        [orientation]="'horizontal'"
        [class.invalid-property]="isMandatoryPropertyInvalid(v)"
      >
        <kendo-label [for]="prop">{{ getProperty(v.value.code).description }}</kendo-label>
        <app-select-valid-value
          #prop
          formControlName="value"
          [property]="getProperty(v.value.code)"
          [entityGroupIndex]="_entityGroup.index"
        ></app-select-valid-value>
        @if (v.controls.value.hasError('required') && (v.controls.value.touched || v.controls.value.dirty)) {
        <kendo-formerror>
          <span translate>Validation.Required</span>
        </kendo-formerror>
        }
      </kendo-formfield>
      }
    </div>
  </fieldset>
  <fieldset
    kendoFormFieldSet
    legend="{{ 'EntityTranslation.UnitConversions' | translate }}"
    [colSpan]="2"
    [cols]="2"
  >
    <ng-container formArrayName="unitConversions">
      @for (v of unitConversionsActive; track v; let i = $index) {
      <kendo-formfield [colSpan]="1" [orientation]="'horizontal'" [formGroupName]="i">
        <kendo-numerictextbox
          formControlName="convFactor"
        ></kendo-numerictextbox>
      </kendo-formfield>
      <kendo-formfield [colSpan]="1" [orientation]="'horizontal'" [formGroupName]="i">
        <kendo-dropdownlist
          formControlName="unitCode"
          [data]="units"
          textField="unitCode"
          valueField="unitCode"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </kendo-formfield>
      <kendo-formfield [colSpan]="1" [orientation]="'horizontal'" [formGroupName]="i">
        <button
          [disabled]="!canChangeUnit(v.controls.unitCode.value)"
          kendoButton
          type="button"
          (click)="removeUnitConversion(i)"
          themeColor="error"
          [svgIcon]="minusIcon"
          title="{{ 'App.Remove' | translate }}"
        ></button>
      </kendo-formfield>
      }
      <kendo-formfield [colSpan]="3" [orientation]="'horizontal'">
        <button
          kendoButton
          type="button"
          (click)="addNewunitConversion()"
          themeColor="primary"
          [svgIcon]="plusIcon"
          title="{{ 'App.Add' | translate }}"
        ></button>
      </kendo-formfield>
    </ng-container>
    @if (unitConversions.errors != null) {
    <span class="validation-text">{{ unitConversions.errors['error'] }}</span>
    }
  </fieldset>
  <fieldset
    kendoFormFieldSet
    legend="{{ 'EntityTranslation.RelationMaterial' | translate }}"
    [colSpan]="6"
  >
    <kendo-grid
      class="entity-relation-table"
      [data]="entityRelationGridData"
    >
      <ng-template kendoGridToolbarTemplate>
        <kendo-grid-spacer></kendo-grid-spacer>
        <button
          kendoButton
          type="button"
          (click)="addNewEntityRelation()"
          [svgIcon]="plusIcon"
          [primary]="true"
        ></button>
      </ng-template>
      <kendo-grid-column
        field="entityIndex"
        [title]="'EntityTranslation.Activity' | translate"
        [width]="300"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div [formGroup]="dataItem.relationGroup">
            <app-select-entity
              formControlName="entityIndex"
              [entityTypeCode]="'ACTIVITY'"
              [showLable]="false"
              (selectedEntity)="onEntityRelationEntitySelected($event, dataItem.formIndex)"
            ></app-select-entity>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="relation"
        [title]="'EntityTranslation.Relation' | translate"
        [width]="130"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div
            [formGroup]="dataItem.relationGroup"
            [class.invalid-hour-relation]="isRelationInvalid(dataItem.relationGroup)"
          >
            <kendo-numerictextbox
              [decimals]="12"
              [format]="'n3'"
              formControlName="relation"
            ></kendo-numerictextbox>
            @if (getRelationErrorKey(dataItem.relationGroup); as relationErrorKey) {
            <kendo-formerror>
              <span translate>{{ relationErrorKey }}</span>
            </kendo-formerror>
            }
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="unitCode"
        [title]="'App.UnitCode' | translate"
        [width]="120"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div [formGroup]="dataItem.relationGroup">
            <kendo-dropdownlist
              formControlName="unitCode"
              [data]="units"
              textField="unitCode"
              valueField="unitCode"
              [valuePrimitive]="true"
            ></kendo-dropdownlist>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="direction"
        [title]="'App.Direction' | translate"
        [width]="90"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div
            [formGroup]="dataItem.relationGroup"
            [class.invalid-direction-relation]="isDirectionInvalid(dataItem.relationGroup)"
          >
            <app-select-entity-relation-direction formControlName="direction"></app-select-entity-relation-direction>
            @if (getDirectionErrorKey(dataItem.relationGroup); as directionErrorKey) {
            <kendo-formerror>
              <span translate>{{ directionErrorKey }}</span>
            </kendo-formerror>
            }
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="inTactical"
        [title]="'EntityTranslation.Tactical' | translate"
        [width]="70"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="inTactical"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="inOperative"
        [title]="'EntityTranslation.Operative' | translate"
        [width]="70"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="inOperative"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="isPreferred"
        [title]="'EntityTranslation.Preferred' | translate"
        [width]="70"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="isPreferred"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        [title]="''"
        [width]="70"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          <button
            kendoButton
            themeColor="error"
            type="button"
            [svgIcon]="minusIcon"
            [size]="'small'"
            (click)="removeEntityRelation(dataItem.formIndex)"
          ></button>
        </ng-template>
        <ng-template kendoGridFooterTemplate></ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </fieldset>
</form>
<kendo-dialog-actions layout="end">
  @if (isNew) {
  <button
    kendoButton
    type="submit"
    (click)="onSubmit()"
    [disabled]="!entityForm.valid || disableSubmit"
    [primary]="true"
  >
    {{ 'App.Add' | translate }}
  </button>
  } @if (!isNew) {
  <button
    kendoButton
    type="submit"
    [disabled]="!entityForm.valid || disableSubmit"
    (click)="onSubmit()"
    [primary]="true"
  >
    {{ 'App.Update' | translate }}
  </button>
  }
</kendo-dialog-actions>

@if (confirmBudgetRemove) {
<app-confirmation-dialog
  (conformationDialogCloseEvent)="confirmBudgetRemoval($event)"
  [msg]="confirmBudgetRemovalMsg()"
></app-confirmation-dialog>
} @if (confirmRemoveRelationIndex !== null) {
<app-confirmation-dialog
  (conformationDialogCloseEvent)="confirmEntityRelationRemoval($event)"
  [msg]="confirmEntityRelationRemovalMsg()"
></app-confirmation-dialog>
}
